<template>
  <div class="m-0 dbozone-font bg-romaplus" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-romaplus">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">
            {{ $t("romaplus.paytable.symtable_title") }}
          </h5>
        </section>
      </div>
      <div class="d-flex flex-row mt-5">

        <div class="nav-wild-romaplus d-flex">
          <img class="icon-paytable wild mt-2" :class="`-wild`"
            :src="require(`../../assets/resultGame/romaplus/symbol_0.png`)" alt="" />
          <p class="wild-text text-sub" :class="`-${lang}`"> {{
            $t("romaplus.paytable.symtable_wild") }} </p>
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row mt-4 ml-4">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/romaplus/symbol_2.png`)" alt="" />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">{{ "5 - " + paytable[2][4] }} <br />{{ "4 - " + paytable[2][3] }}
            <br />{{ "3 - " + paytable[2][2] }}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/romaplus/symbol_3.png`)" alt="" />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">{{ "5 - " + paytable[3][4] }} <br />{{ "4 - " + paytable[3][3] }}
            <br />{{ "3 - " + paytable[3][2] }}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-4 ml-4">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/romaplus/symbol_4.png`)" alt="" />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">{{ "5 - " + paytable[4][4] }} <br />{{ "4 - " + paytable[4][3] }}
            <br />{{ "3 - " + paytable[4][2] }}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/romaplus/symbol_5.png`)" alt="" />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">{{ "5 - " + paytable[5][4] }} <br />{{ "4 - " + paytable[5][3] }}
            <br />{{ "3 - " + paytable[5][2] }}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-4 ml-4">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/romaplus/symbol_6.png`)" alt="" />
        </div>
        s
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">{{ "5 - " + paytable[6][4] }} <br />{{ "4 - " + paytable[6][3] }}
            <br />{{ "3 - " + paytable[6][2] }}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/romaplus/symbol_7.png`)" alt="" />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">{{ "5 - " + paytable[7][4] }} <br />{{ "4 - " + paytable[7][3] }}
            <br />{{ "3 - " + paytable[7][2] }}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-4 ml-4">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/romaplus/symbol_8.png`)" alt="" />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">{{ "5 - " + paytable[8][4] }} <br />{{ "4 - " + paytable[8][3] }}
            <br />{{ "3 - " + paytable[8][2] }}
          </span>
        </div>
      </div>


      <div class="d-flex flex-column nav-romaplus mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">
            {{ $t("romaplus.bonus.title") }}
          </h5>
        </section>
      </div>

      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/romaplus/symbol_1.png`)" alt="" />
        </div>
      </div>
      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-sub" :class="`-${lang}`">
          {{ $t("romaplus.bonus.text1") }} <br />
          {{ $t("romaplus.bonus.text2") }}
        </p>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/romaplus/bonus2.png`)" alt="" />
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row">
        <div class="d-flex p-2 mt-3 align-items-center">
          <p class="m-0 text-sub" :class="`-${lang}`">
            {{ $t("romaplus.bonus.text3") }}
          </p>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/romaplus/bonus3.png`)" alt="" />
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row">
        <div class="d-flex p-2 mt-3 align-items-center">
          <p class="m-0 text-sub" :class="`-${lang}`">
            {{ $t("romaplus.bonus.text4") }}
          </p>
        </div>
      </div>

      <div class="d-flex flex-column nav-romaplus mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">
            {{ $t("romaplus.freespin.title") }}
          </h5>
        </section>
      </div>

      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-sub" :class="`-${lang}`">
          {{ $t("romaplus.freespin.text1") }} <br />
          {{ $t("romaplus.freespin.text2") }}
        </p>
      </div>

      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-freespin-romaplus" :class="`-${lang}`">
          {{ $t("romaplus.freespin.text3") }}
        </p>
      </div>
      <div>
        <hr class="hr-freespin-romaplus" />
      </div>
      <div class="col-12 justify-content-center d-flex flex-row">
        <div class="p-0 align-items d-flex">
          <img class="mt-3 icon-paytable-romaplus" :src="require(`../../assets/paytable/romaplus/freespin1.png`)"
            alt="" />
        </div>
      </div>

      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-freespin-romaplus" :class="`-${lang}`">
          {{ $t("romaplus.freespin.text4") }}
        </p>
      </div>
      <div>
        <hr class="hr-freespin-romaplus" />
      </div>
      <div class="col-12 justify-content-center d-flex flex-row">
        <div class="p-0 align-items d-flex">
          <img class="mt-3 icon-paytable-romaplus" :src="require(`../../assets/paytable/romaplus/freespin2.png`)"
            alt="" />
        </div>
      </div>

      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-freespin-romaplus" :class="`-${lang}`">
          {{ $t("romaplus.freespin.text5") }}
        </p>
      </div>
      <div>
        <hr class="hr-freespin-romaplus" />
      </div>
      <div class="col-12 justify-content-center d-flex flex-row">
        <div class="p-0 align-items d-flex">
          <img class="mt-3 icon-paytable-romaplus" :src="require(`../../assets/paytable/romaplus/freespin3.png`)"
            alt="" />
        </div>
      </div>

      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-freespin-romaplus" :class="`-${lang}`">
          {{ $t("romaplus.freespin.text6") }}
        </p>
      </div>
      <div>
        <hr class="hr-freespin-romaplus" />
      </div>
      <div class="col-12 justify-content-center d-flex flex-row">
        <div class="p-0 align-items d-flex">
          <img class="mt-3 icon-paytable-romaplus" :src="require(`../../assets/paytable/romaplus/freespin4.png`)"
            alt="" />
        </div>
      </div>

      <div class="d-flex flex-column nav-romaplus mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">{{ $t('bonusGameBuy.title') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1 mb-2 justify-content-center">
        <img class="mt-3 icon-startbutton" :src="require(`../../assets/paytable/romaplus/feature_buy_${imgLang}.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('bonusGameBuy.text1') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('bonusGameBuy.text2') }}</span>
      </div>

      <div class="d-flex flex-column nav-romaplus mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">
            {{ $t("romaplus.line.title") }}
          </h5>
        </section>
      </div>

      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-sub" :class="`-${lang}`">
          {{ $t("romaplus.line.text1") }} <br />
          {{ $t("romaplus.line.text2") }} <br />
          {{ $t("romaplus.line.text3") }}
        </p>
      </div>
      <div class="justify-content-center d-flex flex-row">
        <img class="icon-paytable" :src="require(`../../assets/paytable/romaplus/pay_line.png`)" alt="" />
      </div>

      <div class="d-flex flex-column nav-romaplus mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">
            {{ $t("romaplus.winbetline.title") }}
          </h5>
        </section>
      </div>

      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-sub" :class="`-${lang}`">
          {{ $t("romaplus.winbetline.text1") }} <br />
          {{ $t("romaplus.winbetline.text2") }} <br />
          {{ $t("romaplus.winbetline.text3") }}
        </p>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'paytable-romaplus',
  props: {
    data: Object,
    lang: String,
    imgLang: String
  },
  data() {
    return {
      paytable: this.data.config.payTable,
    };
  },
};
</script>

<style>
.nav-romaplus {
  background-color: #a11010;
  border-radius: 14px;
}

.icon-paytable {
  width: 100%;
}

.icon-paytable.-wild {
  position: absolute;
  width: 18%;
  /* height: 17.6vw; */
}

.icon-paytable-romaplus {
  width: 42vw;
}

.bg-romaplus {
  background: #391818;
}

.wild-text {
  justify-content: center;
  margin-left: 20vw;
  margin-top: 3vw;
}

@media screen and (max-width: 768px) {
  .bg-romaplus {
    background: #000;
  }
}

.text-freespin-romaplus {
  color: #ffe463;
  font-size: 4.5vw;
}

.nav-wild-romaplus {
  border-radius: 14px 14px 14px 14px;
  border-left-style: solid;
  border-right-style: solid;
  border-top-style: solid;
  border-bottom-style: solid;
  border-color: #a11010;
  width: 100%;
  height: 24.5vw;
  /* margin-left: 17vw; */
}

.icon-paytable.-wild {
  margin-right: 100px;
}

.hr-freespin-romaplus {
  border: 2px solid #ffe463;
  border-radius: 5px;
  margin-top: 0vw;
}

@media screen and (max-width: 768px) {
  .header>div {
    flex-grow: 0;
    width: 33.33%;
  }
}
</style>